// src/features/interview/components/ProctoringAlertModal.jsx
import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { useTheme } from '../../../../hooks/useTheme';

const ProctoringAlertModal = ({
  isOpen,
  message,
  onAcknowledge,
  candidateName = "Candidate",
}) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div 
        className={`
          relative w-full max-w-lg mx-4 sm:mx-6 
          rounded-2xl shadow-2xl overflow-hidden
          ${theme === 'light' 
            ? 'bg-white border border-gray-200' 
            : 'bg-gradient-to-b from-gray-900 to-gray-800 border border-gray-700'}
        `}
      >
        {/* Header */}
        <div className="px-8 pt-8 pb-4 text-center">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100/80 dark:bg-red-900/30">
            <AlertTriangle className="h-10 w-10 text-red-600 dark:text-red-400" />
          </div>
          
          <h2 className={`
            text-2xl font-bold tracking-tight
            ${theme === 'light' ? 'text-gray-900' : 'text-white'}
          `}>
            Attention Required
          </h2>
          
          <p className={`
            mt-2 text-sm
            ${theme === 'light' ? 'text-gray-600' : 'text-gray-400'}
          `}>
            {candidateName}, please read the following carefully
          </p>
        </div>

        {/* Message Content */}
        <div className="px-8 py-6">
          <div className={`
            rounded-xl p-6 text-center leading-relaxed
            ${theme === 'light' 
              ? 'bg-red-50 border border-red-200 text-red-800' 
              : 'bg-red-950/40 border border-red-800/50 text-red-100'}
          `}>
            {message}
          </div>
        </div>

        {/* Footer / Action */}
        <div className="px-8 pb-8 pt-4 flex justify-center">
          <button
            onClick={onAcknowledge}
            className="button"
          >
            <span>I Understand – Continue</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProctoringAlertModal;